/**
 * @ngdoc directive
 * @name sgTransitionNotifierCtrl.controller
 *
 * @description
 * Toon een loading spinner op page transitions en plaats een onzichtbare
 * overlay die clicks afvangt.
 */

'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('sgTransitionNotifierCtrl', sgTransitionNotifierCtrl);

  sgTransitionNotifierCtrl.$inject = ['$scope', '$transitions', '$timeout', 'Labels'];

  function sgTransitionNotifierCtrl ($scope, $transitions, $timeout, Labels) {
    const vm = this;
    vm.LABELS = Labels;
    vm.isLoading = false;

    $scope.$on('transitionnotifier:start', () => {
      vm.isLoading = true;
    });

    $scope.$on('transitionnotifier:end', () => {
      vm.isLoading = false;
    });

    $transitions.onBefore({}, () => {
      vm.isLoading = true;
    });

    $transitions.onSuccess({}, () => {
      // timeout needed to stop events propagating to underlying page
      $scope.$applyAsync(() => {
        vm.isLoading = false;
      });
    });

    $transitions.onError({}, () => {
      vm.isLoading = false;
    });
  }
})();
